import { render } from "./CommunityDetails.vue?vue&type=template&id=556011fc&scoped=true"
import script from "./CommunityDetails.vue?vue&type=script&lang=js"
export * from "./CommunityDetails.vue?vue&type=script&lang=js"

import "./CommunityDetails.vue?vue&type=style&index=0&id=556011fc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556011fc"]])

export default __exports__